import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initSentry } from "@/lib/sentry";
import { initPostHog } from "@/lib/posthog";
import { initInstallPromptCapture, registerServiceWorker } from "@/lib/pwa";

initSentry();
initPostHog();
initInstallPromptCapture();
registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
